import { render, staticRenderFns } from "./Laboratory.vue?vue&type=template&id=45858cec&scoped=true&"
var script = {}
import style0 from "./Laboratory.vue?vue&type=style&index=0&id=45858cec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45858cec",
  null
  
)

export default component.exports